import { DeleteDedicationDto } from '../../../dto/deletededication/deletededicationdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteDedicationRequest extends APIRequest
{
    getDeleteDedicationRequest(): DeleteDedicationDto;
}

export class DeleteDedicationRequestImpl extends APIRequestDtoImpl implements DeleteDedicationRequest
{
    constructor(private getDeleteDedicationData: DeleteDedicationDto)
    {
        super();
    }

    getDeleteDedicationRequest(): DeleteDedicationDto
    {
        return this.getDeleteDedicationData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/deletededication/deletededicationrequest.tsx